import React from 'react'
import * as R from 'ramda'
import { t } from 'ttag'

import { useModal } from 'hooks'

// NOTE: hook that exposes delete interview template catetgory
// modal state and handlers for other local hooks and interview
// templates creator components
export const useDeleteCategoryModal = (state, handlers) => {
  const { activeSection, currentStepIndex, steps, isEditMode } = state
  const {
    handleChangeStep,
    handleChangeMode,
    handleDeleteTemplateSection,
    handleSetResponse,
    handleShowSnackbar,
  } = handlers

  const { id } = activeSection

  const { handleClose, handleOpen, isOpen } = useModal()

  const handleConfirm = React.useCallback(async () => {
    const { error } = await handleDeleteTemplateSection({
      uuid: id,
    })

    if (!R.isNil(error)) {
      // TODO: handle potential errors
    } else {
      const isLastStep = R.equals(currentStepIndex + 1, R.length(steps))

      handleSetResponse(prevState => {
        handleChangeStep(
          steps[isLastStep ? currentStepIndex - 1 : currentStepIndex + 1]?.key,
        )

        return R.over(
          R.lensPath(['sections']),
          R.remove(currentStepIndex, 1),
          prevState,
        )
      })
      isEditMode && handleChangeMode()
      handleClose()
      handleShowSnackbar({
        message: t`Interview template category was successfully deleted.`,
        type: 'success',
      })
    }
  }, [
    currentStepIndex,
    id,
    steps,
    handleClose,
    handleChangeStep,
    handleChangeMode,
    handleDeleteTemplateSection,
    handleSetResponse,
    handleShowSnackbar,
    isEditMode,
  ])

  return {
    handleDeleteCategoryClose: handleClose,
    handleDeleteCategoryConfirm: handleConfirm,
    handleDeleteCategoryOpen: handleOpen,
    isDeleteCategoryOpen: isOpen,
  }
}
